import React from "react";
import { Col, DatePicker, Form, Input } from "antd";
import { defaultDateFormat } from "../constants/Helpers";
import InputCurrency from "./InputCurrency";

const InputTextField = ({ ...props }) => {
  return (
    <>
      {props.condition === "Y" || (props.condition === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Col {...props.responsiveOptions}>
          <Form.Item name={props.formItemName} label={props.formItemLabel}>
            <Input readOnly />
          </Form.Item>
        </Col>
      ) : null}
    </>
  );
};

const InputCurrencyField = ({ ...props }) => {
  return (
    <>
      {props.condition === "Y" || (props.condition === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Col {...props.responsiveOptions}>
          <Form.Item name={props.formItemName} label={props.formItemLabel}>
            <InputCurrency style={{ width: "100%" }} readOnly />
          </Form.Item>
        </Col>
      ) : null}
    </>
  );
};

const DatePickerField = ({ ...props }) => {
  return (
    <>
      {props.condition === "Y" || (props.condition === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Col {...props.responsiveOptions}>
          <Form.Item name={props.formItemName} label={props.formItemLabel}>
            <DatePicker style={{ width: "100%" }} format={defaultDateFormat} disabled />
          </Form.Item>
        </Col>
      ) : null}
    </>
  );
};

const InputFields = ({ ...props }) => {
  return <></>;
};

InputFields.InputTextField = InputTextField;
InputFields.InputCurrencyField = InputCurrencyField;
InputFields.DatePickerField = DatePickerField;

export default InputFields;
